<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <div class="tabs-widget">
        <div class="tab-item active" @click="switchTab('tv_streaming')">
          TV STREAMING
        </div>
      </div>
      <div class="tab-options">
        <b-button type="is-primary" outlined @click="addNew()">ADD NEW TV</b-button>
      </div>
    </div>
    <div class="wrapper-body">
      <div v-if="!loading_tv_list && tv_list.length > 0" class="left-panel">
        <div class="tv-channel-item" v-for="(item, index) in tv_list" :key="index" @click="selectTv(item)">
          <div class="tv-channel-brand">
            <img :src="`${$store.state.ASSETS_BASE_URL}/assets/uploaded/${item.image}`" />
          </div>
          <div class="tv-channel-info">
            <div class="tv-channel-name">
              {{ item.title }}
            </div>
            <div class="tv-channel-status">
              <b-tag v-if="item.visibility == 'Public'" type="is-success">Public</b-tag>
              <b-tag v-else type="is-danger">Unlisted</b-tag>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading_tv_list && tv_list.length == 0" class="left-panel">
        <widgetNotfound title="No TVs" subtitle="You have not added any TV yet."></widgetNotfound>
      </div>
      <div v-if="loading_tv_list" class="left-panel">
        <div class="tv-channel-item" v-for="(item, index) in 10" :key="index">
          <div class="tv-channel-brand">
            <b-skeleton width="80px" height="80px"></b-skeleton>
          </div>
          <div class="tv-channel-info">
            <div class="tv-channel-name">
              <b-skeleton width="100px" height="30px"></b-skeleton>
            </div>
            <div class="tv-channel-status">
              <b-skeleton width="160px" height="20px"></b-skeleton>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selected_item" class="rigth-panel">
        <div class="rigth-panel-header">
          <div class="rigth-panel-header-left">
            <div class="tv-channel-brand">
              <img :src="`${$store.state.ASSETS_BASE_URL}/assets/uploaded/${selected_item.image}`" />
            </div>
            <div class="tv-name">{{ selected_item.title }}</div>
          </div>
          <div class="tv-options">
            <span class="closeButton" @click="selected_item = null">Close</span>
            <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
              <template #trigger>
                <b-icon icon="dots-vertical"></b-icon>
              </template>
              <b-dropdown-item @click="updateTv(selected_item)" aria-role="listitem">Update</b-dropdown-item>
              <b-dropdown-item @click="deleteTv(selected_item)" aria-role="listitem">Delete</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <div class="rigth-panel-body">
          <div class="tv-streaming">
            <ClapprPlayer :src="selected_item.player_url" type="hls"></ClapprPlayer>
          </div>
          <div class="tv-description">
            {{ selected_item.description }}
          </div>
        </div>
      </div>
      <div v-else class="rigth-panel no-data-panel">
        <widgetNotfound title="No TVs Selected" subtitle="Select TV to see its details"></widgetNotfound>
      </div>
    </div>

    <!-- Add new tv -->
    <addNewTvModal v-if="show_form_modal" :value="selected_item" @close="show_form_modal = false" @saved="onAddCvSaved()">
    </addNewTvModal>
  </div>
</template>

<script>
import addNewTvModal from "./components/addNewTvModal.vue";
export default {
  components: {
    addNewTvModal,
  },
  data: () => ({
    show_form_modal: false,
    selected_item: null,
    tv_list: [],
    loading_tv_list: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getTvs();
  },
  methods: {
    deleteTv(item) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "Deleting account",
        message:
          "Are you sure you want to <b>delete</b> tv? This action cannot be undone.",
        confirmText: "Delete Tv",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          vm.$store
            .dispatch("STREAMING_DELETE_TV", {
              id: item.id,
            })
            .then((response) => {
              vm.$buefy.toast.open({
                duration: 5000,
                message: "Tv deleted successfully",
                type: "is-success",
              });
              vm.getTvs();
            })
            .catch((error) => {
              vm.$buefy.toast.open({
                duration: 5000,
                message: "Error deleting tv",
                type: "is-danger",
              });
            });
        },
      });
    },
    updateTv(item) {
      let vm = this;
      vm.selected_item = item;
      vm.show_form_modal = true;
    },
    selectTv(item) {
      let vm = this;
      vm.selected_item = item;
    },
    getTvs() {
      let vm = this;
      vm.loading_tv_list = true;
      vm.$store
        .dispatch("STREAMING_ALL_TVs")
        .then((response) => {
          vm.loading_tv_list = false;
          vm.tv_list = response.data.return;
        })
        .catch((error) => {
          vm.loading_tv_list = false;
        });
    },
    onAddCvSaved() {
      let vm = this;
      vm.selected_item = null;
      vm.show_form_modal = false;
      vm.getTvs();
    },
    addNew() {
      let vm = this;
      vm.selected_item = null;
      vm.show_form_modal = true;
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;

    .tabs-widget {
      display: flex;
      align-items: flex-end;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    display: flex;
    position: relative;

    .left-panel {
      overflow-y: auto;
      padding: 10px;
      height: 100%;
      width: 400px;
      display: flex;
      flex-direction: column;

      @media (max-width: 772px) {
        width: 40%;
      }

      @media (max-width: 662px) {
        width: 100%;
      }

      .tv-channel-item {
        display: flex;
        align-items: center;
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 5px;
        margin-bottom: 10px;
        background: #fff;
        cursor: pointer;

        &:hover {
          background: #f5f5f5;
        }

        .tv-channel-brand {
          width: 100px;
          height: 100px;
          border-radius: 5px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .tv-channel-info {
          margin-left: 10px;

          .tv-channel-name {
            font-size: 16px;
            font-weight: 600;
          }

          .tv-channel-status {
            margin-top: 5px;
          }
        }
      }
    }

    .rigth-panel {
      width: calc(100% - 400px);
      height: 100%;
      background: #fff;
      border-left: 1px solid #ddd;
      display: flex;
      flex-direction: column;

      @media (max-width: 772px) {
        width: 60%;
      }

      @media (max-width: 662px) {
        width: 85%;
        position: absolute;
        background: white;
        top: 0;
        z-index: 999;
        top: 0;
        right: 0px;
        transition: .5s;
        box-shadow: -10px 10px 10px rgba(0, 0, 0, 0.089);

        &.no-data-panel {
          display: none;
        }
      }

      .rigth-panel-header {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 10px;
        border-bottom: 1px solid #ddd;

        .rigth-panel-header-left {
          display: flex;
          align-items: center;

          .tv-channel-brand {
            width: 30px;
            height: 30px;
            border-radius: 5px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .tv-name {
            font-size: 16px;
            font-weight: 600;
            margin-left: 10px;
          }
        }

        .tv-options {
          display: flex;
          align-items: center;

          .closeButton {
            color: red;
            cursor: pointer;
            margin-right: 10px;
            display: none;

            @media (max-width: 662px) {
              display: block;
            }
          }
        }
      }

      .rigth-panel-body {
        height: calc(100% - 60px);
        padding: 10px;
        overflow-y: auto;

        .tv-streaming {
          width: 100%;
          height: 400px;
          border-radius: 10px;
          overflow: hidden;
        }

        .tv-description {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
